import { type FormEvent, useState } from "react"
import { supabase } from "@/lib/supabase"

export function Contact() {
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true)
    setError("")

    const form = e.currentTarget
    const name = (form.elements.namedItem("name") as HTMLInputElement).value
    const email = (form.elements.namedItem("email") as HTMLInputElement).value
    const phone = (form.elements.namedItem("phone") as HTMLInputElement).value
    const message = (form.elements.namedItem("message") as HTMLTextAreaElement)
      .value

    const { error: err } = await supabase.rpc("insert_contact", {
      p_name: name,
      p_email: email,
      p_phone: phone || null,
      p_message: message,
    })

    setLoading(false)
    if (err) {
      setError(err.message)
    } else {
      setSubmitted(true)
    }
  }

  const handleReset = () => {
    setSubmitted(false)
    setError("")
  }

  return (
    <section id="contact" className="border-t border-gray-200 py-20">
      <div className="mx-auto max-w-[1400px] px-8">
        <div className="grid gap-16 md:grid-cols-2">
          {/* Left - Contact info */}
          <div className="reveal">
            <h2 className="font-heading text-[40px] leading-[1.15] text-navy sm:text-[48px]">
              CONTACT US/
              <br />
              FIND OUR OFFICE
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed font-light text-gray-400 italic">
              Contact us for inquiries, quotes, or support. We're here to
              respond promptly and assist you fully.
            </p>

            <div className="mt-10 space-y-6">
              {[
                {
                  icon: (
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      className="h-5 w-5"
                    >
                      <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  ),
                  text: "Call us on +91 7569728595",
                },
                {
                  icon: (
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      className="h-5 w-5"
                    >
                      <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  ),
                  text: "Mon - Sat 8:00 AM - 6:00 PM",
                },
                {
                  icon: (
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      className="h-5 w-5"
                    >
                      <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  ),
                  text: "vikramdwivedi78@gmail.com",
                },
                {
                  icon: (
                    <svg
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      className="h-5 w-5"
                    >
                      <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  ),
                  text: "Employees Colony, Yapral, Hyderabad, Telangana - 500087",
                },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-4">
                  <span className="text-navy">{item.icon}</span>
                  <span className="text-[14px] font-light text-gray-500 italic">
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Form */}
          <div
            className="reveal"
            id="booking"
            style={{ transitionDelay: "150ms" }}
          >
            {submitted ? (
              <div className="flex h-full flex-col items-center justify-center space-y-6 py-20">
                <div className="text-center">
                  <h3 className="font-heading text-3xl text-navy">
                    Message Sent!
                  </h3>
                  <p className="mt-2 text-gray-400">
                    We'll get back to you soon.
                  </p>
                </div>
                <button
                  onClick={handleReset}
                  className="border border-gray-200 bg-gray-100 px-8 py-4 text-[13px] font-light tracking-[0.15em] text-navy uppercase transition-all hover:border-navy hover:bg-navy hover:text-white"
                >
                  Submit Another
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                {error && (
                  <div className="rounded bg-red-500/20 p-3 text-sm text-red-600">
                    {error}
                  </div>
                )}
                <div>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="Name*"
                    className="w-full border-b border-gray-200 bg-transparent py-4 text-[15px] font-light text-navy transition-all outline-none placeholder:text-gray-300 focus:border-navy"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="Email*"
                    className="w-full border-b border-gray-200 bg-transparent py-4 text-[15px] font-light text-navy transition-all outline-none placeholder:text-gray-300 focus:border-navy"
                  />
                </div>
                <div>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone"
                    className="w-full border-b border-gray-200 bg-transparent py-4 text-[15px] font-light text-navy transition-all outline-none placeholder:text-gray-300 focus:border-navy"
                  />
                </div>
                <div>
                  <textarea
                    name="message"
                    rows={4}
                    required
                    placeholder="Message"
                    className="w-full resize-none border-b border-gray-200 bg-transparent py-4 text-[15px] font-light text-navy transition-all outline-none placeholder:text-gray-300 focus:border-navy"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full border border-gray-200 bg-gray-100 py-4 text-[13px] font-light tracking-[0.15em] text-navy uppercase transition-all hover:border-navy hover:bg-navy hover:text-white disabled:opacity-50"
                >
                  {loading ? "Sending..." : "Send"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
